module.exports = __webpack_public_path__ + "img/fat_guy_sil.952d4c00.png";